// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2hrC1","col":"styles_col__32JZG"};